import { Inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map, tap } from 'rxjs/operators';

import { Guid } from '@fitscovery/common/types';
import { Booking, BookingData, PartnerBooking } from '../models/booking.model';
import { BookingService } from '../types';

import { Environment } from '@fitscovery/common/environments';
import { APP_ENVIRONMENT } from '../environment-injection';

@Injectable()
export class ApiBookingService implements BookingService {

  constructor(
    @Inject(APP_ENVIRONMENT) private env: Environment,
    private http: HttpClient
  ) { }

  getPartnerBooking(partnerId: Guid): Observable<PartnerBooking> {
    return <Observable<PartnerBooking>>(this.http.get(`${this.env.azureFunctionsApi.bookings}/bookings/partnerId/${partnerId}/pricing`) as any).pipe(
      map((partnerBookings: PartnerBooking[]) => partnerBookings[0])
    );
  }
  
  getUpcomingBookings(partnerId: Guid): Observable<Booking[]> {
    return <Observable<Booking[]>>this.http.get(`${this.env.azureFunctionsApi.bookings}/bookings/partners/${partnerId}/members/upcoming`);
  }

  updatePartnerBooking(bookingDetails: PartnerBooking): Observable<PartnerBooking> {
    return <Observable<PartnerBooking>>this.http.post(`${this.env.azureFunctionsApi.bookings}/bookings/partnerId/${bookingDetails.partnerId}/pricing`, bookingDetails);
  }

  updateMemberBooking(bookingData: BookingData): Observable<any> {
    return this.http.put(`${this.env.azureFunctionsApi.bookings}/bookings`, bookingData);
  }

}
